<template>
  <v-container fluid>

    <!-- Title -->
    <Title
        :title="isEditing ? 'Editando precios' : 'Precios'"
        description="Registro de los precios de distintos tipos de tablas."
    />

    <!-- Table type prices -->
    <v-form v-if="!isLoading" @submit.prevent="saveChanges" ref="formPrices">
      <v-row>
        <v-col cols="12">
          <v-btn
              class="me-2"
              :color="isEditing ? 'secondary' : 'primary'"
              @click="toggleEditMode"
          >
            <v-icon left>
              {{ isEditing ? 'mdi-close' : 'mdi-pencil' }}
            </v-icon>
            {{ isEditing ? 'Cancelar' : 'Modo Edición' }}
          </v-btn>
          <SaveButton
              :is-loading="isLoading"
              :is-disabled="!isEditing"
              @click="saveChanges"
              v-if="isEditing"
          />
        </v-col>

        <v-col cols="12" sm="6" md="4" lg="3" v-for="quantityTable in quantityTables" :key="quantityTable.id">
          <v-card :class="quantityTable.primaryColor + ' lighten-5'">
            <v-card-title class="py-1 mb-4 white--text" :class="quantityTable.primaryColor">
              <span class="text-h6">{{ quantityTable.displayName }}</span>
            </v-card-title>

            <v-card-text>
              <v-row>
                <v-col cols="12">
                  <v-text-field
                      prepend-inner-icon="mdi-currency-usd"
                      v-model="quantityTable.priceMxn"
                      label="Precio (MXN)"
                      outlined
                      dense
                      hide-details
                      :color="quantityTable.primaryColor"
                      :disabled="!isEditing"
                      type="number"
                      :rules="[rules.required, rules.double]"
                  />
                </v-col>
<!--                <v-col cols="12">-->
<!--                  <v-text-field-->
<!--                      prepend-inner-icon="mdi-currency-usd"-->
<!--                      v-model="quantityTable.priceUsd"-->
<!--                      label="Precio (USD)"-->
<!--                      outlined-->
<!--                      dense-->
<!--                      hide-details-->
<!--                      :color="quantityTable.primaryColor"-->
<!--                      :disabled="!isEditing"-->
<!--                      type="number"-->
<!--                      :rules="[rules.required, rules.double]"-->
<!--                  />-->
<!--                </v-col>-->
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-form>

    <!-- Loading -->
    <OverlayLoading v-else/>
  </v-container>
</template>

<script lang="ts">
import Vue from "vue";

import PricesServices from "@/services/prices/PricesServices";

import {QuantityTableType} from "@/services/prices/entities/QuantityTableType";

import throwErrorMessage from "@/utils/ErrorMessage";
import throwSuccessMessage from "@/utils/SuccessMessage";

import Title from "@/components/Title.vue";
import OverlayLoading from "@/components/OverlayLoading.vue";
import SaveButton from "@/components/buttons/SaveButton.vue";

export default Vue.extend({
  name: "PricesPage",
  components: {
    SaveButton,
    Title,
    OverlayLoading,
  },
  data() {
    return {
      // Table
      quantityTables: [] as QuantityTableType[],
      originalQuantityTables: [] as QuantityTableType[],

      // Rules
      rules: {
        required: (value: string) => !!value || "Campo requerido",
        double: (value: string) => !isNaN(parseFloat(value)) || "Ingresa un número válido",
      },

      // Loading
      isLoading: false as boolean,

      // Editing
      isEditing: false as boolean,
    };
  },

  methods: {
    async getQuantityTables() {
      this.isLoading = true;
      try {
        this.quantityTables = await PricesServices.getQuantityTableTypes();
        this.originalQuantityTables = [...this.quantityTables];
      } finally {
        this.isLoading = false;
      }
    },

    async saveChanges() {
      this.isLoading = true;
      try {
        // Validate form
        const form = this.$refs.formPrices as any;
        if (!form.validate()) {
          throwErrorMessage("Asegúrate de llenar todos los campos correctamente");
          return;
        }

        // Check if there are changes
        if (JSON.stringify(this.quantityTables) === JSON.stringify(this.originalQuantityTables)) {
          throwErrorMessage("No hay cambios que guardar");
          return;
        }
        await PricesServices.updateQuantityTablePrices(this.quantityTables);
        throwSuccessMessage("Precios actualizados correctamente");
        this.toggleEditMode();
        await this.getQuantityTables();
      } finally {
        this.isLoading = false;
      }
    },

    toggleEditMode() {
      if (this.isEditing) {
        this.quantityTables = JSON.parse(JSON.stringify(this.originalQuantityTables));
      } else {
        this.originalQuantityTables = JSON.parse(JSON.stringify(this.quantityTables));
      }
      this.isEditing = !this.isEditing;
    },
  },

  created() {
    this.getQuantityTables();
  },
});
</script>

<style scoped>
</style>